import * as api from  './api'
import * as reducers from './slice-reducers'
import { AppDispatch } from 'src/app/store'
import {
  downloadCsv,
  getActualDateFormated,
  getCsvFromObjectArray,
  getStringWithOutColomns,
  getTransformedDate
} from 'src/core/helpers'
import {
  BigOrder,
  GetOneOrderAllOrderItemsResponse,
  GetOneOrderResponse,
  OrderPurchasesCertificate
} from 'src/core/models'

export const getMyOrdersList = (total: number = 4, currency_code: string = null) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setMyOrdersLoading(true))
    const data: BigOrder[] = await api.getMyOrdersListAPI(total, currency_code)
    dispatch(reducers.setMyOrdersLoading(false))
    dispatch(reducers.setMyOrdersResponse(data))
    dispatch(reducers.setFilteredOrders(data))
  }catch (error){
    dispatch(reducers.setMyOrdersLoading(false))
    dispatch(reducers.setMyOrdersError(error))
  }
}

export const getPurchasesFromCertificates = (certificates: string[]) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setOrderCertificatesLoading(true))
    const data: OrderPurchasesCertificate[] = await api.getPurchasesFromCertificatesAPI(certificates)
    dispatch(reducers.setOrderCertificatesData(data))
    dispatch(reducers.setOrderCertificatesSuccess(true))
    dispatch(reducers.setOrderCertificatesLoading(false))

    // Download Data
    const results = data.map((certificate) => {
      return {
        Company: getStringWithOutColomns(certificate.companyName),
        Project: getStringWithOutColomns(certificate.projectName),
        Date: getStringWithOutColomns(getTransformedDate(certificate.created)),
        TCO2: certificate.co2_amount,
        Amount: certificate.amount?.toFixed(3),
        Price: (certificate.amount / certificate.co2_amount)?.toFixed(2),
        Currency: certificate.currency
      }
    })
    const csv = getCsvFromObjectArray(results)
    downloadCsv(csv, `Orders_${getActualDateFormated()}`)

    // Reset State
    dispatch(reducers.resetOrderCertificatesState())
  }catch (error){
    dispatch(reducers.setOrderCertificatesLoading(false))
    dispatch(reducers.setOrderCertificatesSuccess(false))
  }
}

export const getOneOrder = (
  orderId: number,
  orderItemId: number,
  currency_code: string = null) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setGetOneOrderLoading(true))
    const data: GetOneOrderResponse = await api.getOneOrderAPI(orderId, orderItemId, currency_code)
    dispatch(reducers.setGetOneOrderData(data))
    dispatch(reducers.setGetOneOrderLoading(false))
  }catch (error){
    dispatch(reducers.setGetOneOrderLoading(false))
    dispatch(reducers.setGetOneOrderError(error))
  }
}

export const getOneOrderAllOrdersItems = (
  orderId: number,  currency_code: string = null) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setGetAllOrderItemsLoading(true))
    const data: GetOneOrderAllOrderItemsResponse = await api.getOneOrderAllOrderItemsAPI(orderId, currency_code)
    dispatch(reducers.setGetAllOrderItemsData(data))
    dispatch(reducers.setGetAllOrderItemsLoading(false))
  }catch (error){
    dispatch(reducers.setGetAllOrderItemsLoading(false))
    dispatch(reducers.setGetAllOrderItemsError(error))
  }
}
